import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../../common/Button";
import Tooltip from "./Tooltip";
import Grammar from "./Grammar";

const Tip = ( props ) => {

  const questionView = useSelector( state => state.questionView );

  const { t } = useTranslation();

  return (
    <div className="btn-viewopen-wrap">
      { !! questionView.tooltipStatus && <Tooltip /> }
      <Button className={ clsx( 'btn-viewopen', questionView.isShowTip && 'on' ) } onClick={ props.onShow }>{ t( 'LC_05_20.msg009' ) }</Button>
      { questionView.isShowTip && <Grammar /> }
    </div>
  );

};

export default Tip;
